import _ from 'lodash';
import constants from './constants';

// 空检测，underscore只提供对object和array的检测
// 'null'不被认为是空值
function isEmpty(obj) {
  if (typeof obj === 'number' || typeof obj === 'string') {
    if (obj === '' || obj === null || obj === undefined) {
      return true;
    }
    return false;
  } if (typeof obj === 'undefined') {
    return true;
  }
  return _.isEmpty(obj);
}
// 检测宿主
function getEnv() {
  const ua = navigator.userAgent.toLowerCase();
  if (ua.indexOf('micromessenger') !== -1) {
    return constants.env.Weixin;
  } if (typeof window.androidNativeObject !== 'undefined') {
    return constants.env.Android;
  } if (typeof window.webkit !== 'undefined' && typeof window.webkit.messageHandlers !== 'undefined'
   && typeof window.webkit.messageHandlers.mtNativeBridge !== 'undefined') {
    return constants.env.iOS;
  }
  return constants.env.Browser;
}
function isWeixin() {
  return getEnv() === constants.env.Weixin;
}
// 删除url中参数
function delParamFromUrlString(url, ref) {
  let str = '';
  if (url.indexOf('?') !== -1) { str = url.substr(url.indexOf('?') + 1); } else { return url; }
  let arr = [];
  let returnurl = '';
  if (str.indexOf('&') !== -1) {
    arr = str.split('&');
    arr.forEach((value) => {
      if (value.split('=')[0] !== ref) {
        returnurl = `${returnurl + value.split('=')[0]}=${value.split('=')[1]}&`;
      }
    });
    return `${url.substr(0, url.indexOf('?'))}?${returnurl.substr(0, returnurl.length - 1)}`;
  }

  arr = str.split('=');
  if (arr[0] === ref) { return url.substr(0, url.indexOf('?')); }
  return url;
}
function getUrlParam(name) {
  return getParamFromUrlString(window.location.search.substr(1), name);
}

function getParamFromUrlString(url, name) {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`); // 构造一个含有目标参数的正则表达式对象
  const r = url.match(reg); // 匹配目标参数
  if (r != null) { return r[2]; }
  return null; // 返回参数值
}
function addParamForUrl(url, name, value) {
  if (!value) {
    return url;
  }
  url = delParamFromUrlString(url, name);
  return `${url}${url.indexOf('?') > -1 ? '&' : '?'}${name}=${value}`;
}
function uuidGenerator() {
  function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
  return (`${S4() + S4()}-${S4()}-${S4()}-${S4()}-${S4()}${S4()}${S4()}`);
}
export default {
  getParamFromUrlString,
  addParamForUrl,
  delParamFromUrlString,
  getUrlParam,
  isEmpty,
  isWeixin,
  uuidGenerator,
}
